(function () {
  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-rasm-card-swatch]');
    if (!swatch) return;

    event.preventDefault();
    event.stopPropagation();

    var card = swatch.closest('[data-rasm-card]');
    if (!card) return;

    card.querySelectorAll('[data-rasm-card-swatch]').forEach(function (button) {
      var selected = button === swatch;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', String(selected));
    });

    if (swatch.dataset.image) {
      var image = card.querySelector('[data-rasm-card-image]');
      if (image) {
        image.src = swatch.dataset.image;
        image.removeAttribute('srcset');
        image.alt = swatch.dataset.imageAlt || image.alt;
      }
    }

    card.querySelectorAll('[data-rasm-card-link]').forEach(function (link) {
      if (swatch.dataset.variantUrl) link.href = swatch.dataset.variantUrl;
    });

    var quickAdd = card.querySelector('[data-rasm-card-quick-add]');
    if (quickAdd && swatch.dataset.variantId) {
      quickAdd.dataset.variantId = swatch.dataset.variantId;
    }

    var price = card.querySelector('[data-rasm-card-price]');
    if (price && swatch.dataset.price) price.textContent = swatch.dataset.price;
  });

  // Handle Quick Add to Bag on product cards
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-rasm-card-quick-add]');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('add error');
      return res.json();
    })
    .then(function () {
      btn.textContent = '✓';
      setTimeout(function () {
        btn.disabled = false;
        btn.textContent = originalText;
      }, 1000);
      if (window.RasmCartDrawer) {
        window.RasmCartDrawer.refresh();
        window.RasmCartDrawer.open();
      }
    })
    .catch(function (err) {
      console.error(err);
      btn.disabled = false;
      btn.textContent = originalText;
    });
  });
})();
